const useSeqItem = () => {
  const sortSeqItem = (items: any, key: string) => {
    items.sort((a: any, b: any) => a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0));
    items.forEach((item: any, index: number) => {
      item[key] = index + 1;
    });

    return items;
  }

  const raiseSeqItem = (items: any, key: string, seq: number) => {
    const _items = [...items];
    const index = _items.findIndex(item => item[key] === seq);
    _items[index][key]--;
    _items[index - 1][key]++;

    return sortSeqItem(_items, key);
  }

  const lowerSeqItem = (items: any, key: string, seq: number) => {
    const _items = [...items];
    const index = _items.findIndex(item => item[key] === seq);
    _items[index][key]++;
    _items[index + 1][key]--;

    return sortSeqItem(_items, key);
  }

  return {
    raiseSeqItem,
    lowerSeqItem,
  };
}

export default useSeqItem;
